import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

// Only the onboarding email sends this intent, so existing activation links ignore the flag.
export function isSelfServeOnboardingLink(
  searchParams: URLSearchParams,
  flags: LDFlagSet,
): boolean {
  return !!flags.selfServeOnboarding && searchParams.get('intent') === 'onboarding';
}
